module.exports = __webpack_public_path__ + "img/step4.bf547268.png";